import(/* webpackMode: "eager", webpackExports: ["TeamWidgetTeaser"] */ "/app/webapp/app/pwa/(main-layout)/team/[teamId]/(simple-layout)/widgets/components/TeamWidgetTeaser.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Match"] */ "/app/webapp/app/pwa/components/match/Match.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RoundSelect"] */ "/app/webapp/app/pwa/components/round/RoundSelect.tsx");
